export default "/assets/images/app-screen3.31a537f71ca97fc1.jpg";